/**
 * @generated SignedSource<<9c93fdc84d6ebb9c577adda953773126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationICAScreenQuery$variables = Record<PropertyKey, never>;
export type IntegrationICAScreenQuery$data = {
  readonly store: {
    readonly integrationICAMinButik: {
      readonly authRequests: ReadonlyArray<{
        readonly expiresAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
        } | null;
        readonly link: string | null;
      }> | null;
    } | null;
  };
};
export type IntegrationICAScreenQuery = {
  response: IntegrationICAScreenQuery$data;
  variables: IntegrationICAScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationICAScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ICAMinButikIntegration",
            "kind": "LinkedField",
            "name": "integrationICAMinButik",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ICAMinButikAuthRequest",
                "kind": "LinkedField",
                "name": "authRequests",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "expiresAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "StoreFormattedDate"
                      }
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationICAScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ICAMinButikIntegration",
            "kind": "LinkedField",
            "name": "integrationICAMinButik",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ICAMinButikAuthRequest",
                "kind": "LinkedField",
                "name": "authRequests",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "expiresAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "style",
                            "value": "DEFAULT"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "storeFormattedDate",
                        "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                      }
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e5b4908cf40dbd3d59e0da4d98f2402",
    "id": null,
    "metadata": {},
    "name": "IntegrationICAScreenQuery",
    "operationKind": "query",
    "text": "query IntegrationICAScreenQuery {\n  store {\n    integrationICAMinButik {\n      authRequests {\n        expiresAtDate {\n          ...StoreFormattedDate\n        }\n        link\n      }\n    }\n    id\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n"
  }
};
})();

(node as any).hash = "5ec3add727629c8fb2531cab86236c95";

export default node;
